$(document).ready(function() {
  function isElementInViewport(el) {
    const rect = el.get(0).getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  function checkVideosInView() {
    $('.video-autoplay').each(function() {
      const section = $(this);
      const video = section.find('video').get(0);

      if (isElementInViewport(section) && video.paused) {
        video.play();
      }
    });
  }

  // Run on scroll and on load
  $(window).on('scroll load', function() {
    checkVideosInView();
  });
});

$(document).ready(function() {$('section .accordion').click(function() {$(this).siblings('.accordion[aria-expanded="true"]').attr('aria-expanded', 'false');});});